import { Link } from 'react-router-dom';
import type { News } from '@/types/content';

interface NewsCardProps {
  news: News;
  variant?: 'card' | 'row';
}

export default function NewsCard({ news, variant = 'card' }: NewsCardProps) {
  if (variant === 'row') {
    return (
      <Link
        to={`/detail/news/${news.id}`}
        className="group flex flex-col gap-4 overflow-hidden rounded-lg border border-background-200 bg-background-50 p-3 transition-all duration-300 hover:border-primary-300 sm:flex-row"
      >
        <div className="relative h-48 w-full shrink-0 overflow-hidden rounded-md sm:h-32 sm:w-52">
          <img
            src={news.cover}
            alt={news.title}
            title={`${news.title} - 花絮资讯`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="flex min-w-0 flex-1 flex-col justify-between py-1">
          <div>
            <div className="flex items-center gap-2 text-xs text-foreground-400">
              <span className="flex items-center gap-1">
                <i className="ri-newspaper-line" />
                花絮资讯
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-time-line" />
                {news.date}
              </span>
            </div>
            <h3 className="mt-2 line-clamp-2 font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-500">
              {news.title}
            </h3>
            <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-500">
              {news.excerpt}
            </p>
          </div>
          <div className="mt-2 flex flex-wrap gap-1.5">
            {news.tags.slice(0, 3).map((tag) => (
              <span key={tag} className="rounded-full bg-accent-100 px-2 py-0.5 text-xs text-accent-900">
                {tag}
              </span>
            ))}
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/detail/news/${news.id}`}
      className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300"
    >
      <div className="relative h-44 w-full overflow-hidden">
        <img
          src={news.cover}
          alt={news.title}
          title={`${news.title} - 花絮资讯`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-full bg-primary-500 px-2.5 py-1 text-xs font-label text-background-50">
          花絮
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <div className="flex items-center gap-1 text-xs text-foreground-400">
          <i className="ri-time-line" />
          {news.date}
        </div>
        <h3 className="mt-2 line-clamp-2 font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-500">
          {news.title}
        </h3>
        <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-500">
          {news.excerpt}
        </p>
        <span className="mt-3 inline-flex items-center gap-1 text-sm font-label text-primary-500">
          阅读全文
          <i className="ri-arrow-right-s-line" />
        </span>
      </div>
    </Link>
  );
}